import React, {FC} from 'react';
import {newsType} from '../../../types/news';
import useFetchNews from '../../../hooks/news/useFetchNews';

import NewsItem from './NewsItem';
import NewsItemMobile from './NewsItemMobile';

import UILoadingIndicator from '../../UICommon/UILoadingIndicator';
import UIErrorIndicator from '../../UICommon/UIErrorIndicator';
import UIButtonCommon from '../../UIButtons/UIButtonCommon';
import UIHeading from '../../UICommon/UIHeading';


const NewsGridComponent: FC = () => {
  const {data, fetchNextPage, hasNextPage} = useFetchNews();

  if (!data || data == null) {
    return <UILoadingIndicator />;
  }

  if (data.pages.length === 0) {
    return (
      <UIErrorIndicator message='Ett fel uppstod, om felet är återkommande vänligen kontakta oss på canita@mih.nu' />
    );
  }

  return (
    <>
      <div className='w-full hidden lg:block py-12'>
        <UIHeading
          text={'Nyheter'}
          extraStyles='mt-16 mb-8'
        />
        {data && data.pages.map((page, pageIndex) => (
          <div id={`${pageIndex}`} key={pageIndex} className='wrapper gap-6 mt-6'>
            {page.results
                .sort((a: newsType, b: newsType) => a.order - b.order)
                .map((el: newsType) => (
                  <NewsItem
                    key={el.id}
                    id={el.id}
                    slug={el.slug}
                    title={el.title}
                    byline={el.byline}
                    image={el.image}
                    tag={el.tags}
                  />
                ))}
          </div>
        ))}
      </div>
      <div className='w-full lg:hidden'>
        <UIHeading
          text={'Nyheter'}
          extraStyles='mt-16 mb-8'
        />
        {data && data.pages.map((page, pageIndex) => (
          <div id={`${pageIndex}`} key={pageIndex} className='wrapper gap-6 mt-6'>
            {page.results
                .sort((a: newsType, b: newsType) => a.order - b.order)
                .map((el: newsType) => (
                  <NewsItemMobile
                    key={el.id}
                    id={el.id}
                    slug={el.slug}
                    title={el.title}
                    byline={el.byline}
                    image={el.image}
                    tag={el.tags}
                  />
                ))}
          </div>
        ))}
      </div>
      {hasNextPage && (
        <div className='w-full flex justify-center mt-9'>
          <UIButtonCommon
            buttonTitle='Visa mer nyheter'
            buttonType='button'
            variant='whitePink'
            onClick={() => fetchNextPage()}
          />
        </div>
      )}
    </>
  );
};


export default NewsGridComponent;
